export const REFUND_TYPE = {
  full: 'full',
  partial: 'partial',
  cash: 'cash',
  norefund: 'norefund'
};

export const CANCELLED_STATUS = 'CANCELLED';
